import { render, staticRenderFns } from "./IconDelete.vue?vue&type=template&id=6734173e&scoped=true"
import script from "./IconDelete.vue?vue&type=script&lang=js"
export * from "./IconDelete.vue?vue&type=script&lang=js"
import style0 from "./IconDelete.vue?vue&type=style&index=0&id=6734173e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6734173e",
  null
  
)

export default component.exports